import { resetThinksToDoError } from "./slice";
import { ThinksToDoType } from "./thinksToDoType";

export const thinksToDoReducer = {
  resetScheduledUpcomingInterviewsList: (state: ThinksToDoType) => {
    state.scheduledUpcomingInterviews = [];
  },
  resetThinksToDoSuccess: (state: ThinksToDoType) => {
    state.error = null;
  },
  resetThinksToDoError: (state: ThinksToDoType) => {
    state.success = null;
  },
  resetThinksToDoMessage: (state: ThinksToDoType) => {
    state.message = null;
  },
  resetThinksToDoStatusCode: (state: ThinksToDoType) => {
    state.statusCode = null;
  },
  resetThinksToDoUpdateFetching: (state: ThinksToDoType) => { 
    state.updateFetching=false
  },
  resetJobClosureListData: (state: ThinksToDoType) => {
    state.jobClosureListData = [];
  },
  resetJobClosureTotalCount: (state: ThinksToDoType) => {
    state.jobClosureTotalCount = 0;
  },
  resetJobClosureListForRM: (state: ThinksToDoType) => {
    state.jobClosureListForRM = [];
  },
  resetTotalCountRM: (state: ThinksToDoType) => {
    state.totalCountRM = 0;
  },
  resetJobClosureRatingList: (state: ThinksToDoType) => {
    state.jobClosureRatingList = {
      job_id: null,
      status: null,
      approval_updated_at:"",
      rating_comment: "",
      count: null,
      ratings:[],
    };
  },
  resetUnApprovedInvoiceCountData: (state: ThinksToDoType) => {
    state.unApprovedInvoiceCountData = [];
  },
  resetRegularizeApprovalPendingList: (state: ThinksToDoType) => {
    state.regularizeApprovalPendingList = [];
  },
  resetUnApprovedInvoiceTotalCount: (state: ThinksToDoType) => {
    state.unApprovedInvoiceTotalCount = 0;
  },
  resetUsersWeeklyApprovedInvoiceTotalCount: (state: ThinksToDoType) => {
    state.approvedInvoiceTotalCount=0;
    state.usersWeeklyApprovedInvoiceTotalCount=0;
  },
};
